// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"302":"954154e1","453":"75a81143","719":"2c9689e2"}[chunkId] + ".chunk.js";
};